import confirmation from '../../assets/img/icons/confirmation.svg';
import gift from '../../assets/img/icons/gift.svg';
import { Container, Content } from './styles';

export function WeddingList() {

    return (
        <Container id="lista-de-presentes">
            <h1>Lista de Presentes | Confirmação de Presença</h1>
            <p> 
                Queridos amigos, <br/><br/>
                Fizemos essa lista de presentes que são itens meramente ilustrativos pois serão revertidos e receberemos os valores dos presentes. Esses itens são realmente o que estamos precisando para mobília da casa e lua de mel.
                <br/><br/>
                No site é possivel parcelar em até 6x, para quem optar a compra pelo site há uma opção de cartão postal que surge antes de finalizar a compra, mas essa escolha aumentará o custo do presente. Há a opção de retirar que fica abaixo dos cartões postais sugeridos pelo site com a seguinte frase: "não gostaria de enviar um cartão", é só clicar nessa opção.
                <br/><br/>
                Para quem desejar disponibilizaremos o nosso pix (celular): 84988178707 - Wellton Quirino Alves da Silva
                <br/><br/>
                Somos gratos pela sua participação em nossas vidas!
            </p>
            <Content>
                <a href="https://noivos.casar.com/renataewellton#/presentes" className="cardLista" target="_blank" rel="noreferrer">
                    <div className="cardLista">
                        <h2>Presentes de Casamento</h2>
                        <img src={gift} style={{ width: "80%" }} alt="Lista de presentes" />
                        <button>Presentear o casal</button>
                    </div>
                </a>
                <a href="https://noivos.casar.com/renataewellton#/rsvp" className="cardLista" target="_blank" rel="noreferrer">
                    <div className="cardLista">
                        <h2>Confirme sua Presença</h2>
                        <img src={confirmation} style={{ width: "75%" }} alt="Confirmação de presença" />
                        <button>Confirmar presença</button>
                    </div>
                </a>
            </Content>
        </Container>
    );
}